import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import styles from '@vp-ui/components/VpTeleprompterOverlay/VpTeleprompterOverlay.module.less';


const promptTextToPlain = (raw) => {
  if (!raw || typeof raw !== 'string') return '';

  const trimmed = raw.trim();
  if (!trimmed.includes('<')) {
    return trimmed;
  }

  const withBreaks = trimmed
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/li>/gi, '\n');

  try {
    const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
    const plain = (doc.body.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
    return plain;
  } catch {
    return trimmed.replace(/<[^>]+>/g, '').trim();
  }
};

export const VpTeleprompterOverlay = ({ text }) => {
  const [visible, setVisible] = useState(true);
  const displayText = useMemo(() => promptTextToPlain(text), [text]);

  if (!displayText) return null;

  return (
    <>
      <button
        className={styles.vpToggleButton}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide question' : 'Show question'}
      >
        {visible
          ? <VisibilityOffIcon fontSize="small" />
          : <VisibilityIcon fontSize="small" />
        }
      </button>
      {visible && (
        <div className={styles.vpOverlay}>
          <div className={styles.vpOverlayInner}>
            <p className={styles.vpText}>{displayText}</p>
          </div>
        </div>
      )}
    </>
  );
};

VpTeleprompterOverlay.propTypes = {
  text: PropTypes.string,
};

export default VpTeleprompterOverlay;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTeleprompterOverlay/VpTeleprompterOverlay.jsx